import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import NotificationDrawer from './NotificationDrawer';
import { HYPERDRIVE } from 'utilities/constants';
import { getData } from 'utilities/common';
import NotificationDrawerHyperdrive from './NotificationDrawerHyperdrive';
import { openCustomDrawer } from '../../redux/slices/modalSlice';
import { useDispatch } from 'react-redux';

const NotificationCount = () => {
  const dispatch = useDispatch()
  const count = useSelector(state => state.notifications.notificationCount);
  const [showNotificationDrawer, setShowNotificationDrawer] = useState(false);
  const adminsMode = getData('adminsMode')
  const isHyperdrive = JSON.parse(adminsMode) === HYPERDRIVE

  const handleShowNotificationDrawer = (isHyperdrive) => {
    if(isHyperdrive){
      dispatch(openCustomDrawer({ drawer: 'NOTIFICATIONS', drawerData: {  } }))
    }
    else{
      setShowNotificationDrawer(!showNotificationDrawer);
    }
  };

  return (
    <div className='notifiction-dawer' onClick={() => handleShowNotificationDrawer(isHyperdrive)}>
      <div className='icon-wrapper'>
        <NotificationsNoneIcon />
      </div>
      {count > 0 &&
        <div className='count-number'>{count}</div>
      }
      {
        showNotificationDrawer && <>
          {!isHyperdrive &&
            <NotificationDrawer open={showNotificationDrawer} onClose={handleShowNotificationDrawer} />
          }
        </>
      }
    </div>
  );
};

export default NotificationCount;